import React from 'react'

const NotFound = () => {
  return (
    <div style={{display:'flex', flexDirection:'column', alignItems:'center',justifyContent:'center', height:"30vh",padding:10 }}>
      <h3 style={{color:"cremson",fontSize:25}}>404 - Page Not Found</h3>
      <p style={{fontSize:18,fontStyle:'italic',padding:5}}>Sorry, the page you're looking for doesn't exist.</p>
    </div>
  )
}

export default NotFound